export const getters = {
  linkTreeList: ({ linkTreeList }) => linkTreeList,
};
